

const quickformHandler      = require ('./quickform-handler')


/****************ELEMENTS*****************/
var scrimQuickform
var HTMLwasSelected = false

function HTMLselect(){ //console.log('HTMLselect')

	HTMLwasSelected  = true
}

/****************ELEMENTS*****************/


export function start(detail){ //console.log('Quickform START>', detail.act)
  
	if(!HTMLwasSelected) { HTMLselect() }
	 
	obj[detail.act].start(detail)

}/**/



const obj = {
 
	show:         { start: (detail)=>{  quickformHandler.show(detail)     }},
	hide:         { start: (detail)=>{  quickformHandler.hide(detail)     }},

}/**/


